// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "With this widget you can create a module with multiple expandable topics.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Content card embed",
  id: "content-card",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/content-card/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ContentCardConfigTool" */ "app/components/tools/ContentCardConfigTool/ContentCardConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ContentCardConfigTool"]
  })
};

export default CONFIG;
